import React from "react";
import { colors } from "src/config/colors";
import Link from "src/components/common/Links/Link";
import Box from "@mui/material/Box";
import { StyledSx } from "src/types/StyledSx";
import { YellowRightArrowIcon } from "src/assets/icons";
import { SxProps } from "@mui/system";
import { Theme } from "@emotion/react";

interface LinkWithArrowProps {
  title: string;
  href?: string;
  onClick?: () => void;
  downArrow?: boolean;
  sx?: SxProps<Theme>;
}

const styled: StyledSx = {
  root: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "13px",
    lineHeight: "13px",
    fontWeight: "normal",
    color: colors.darkBlue,
    textDecoration: "none",
    ":hover": {
      svg: { circle: { fill: colors.darkBlue }, path: { fill: colors.yellow } },
      textDecoration: "underline",
    },
  },
};

const LinkWithArrow: React.FC<LinkWithArrowProps> = ({
  title,
  href = "/",
  onClick,
  downArrow = false,
  sx,
}) => {
  return onClick ? (
    <Box onClick={onClick} sx={{ ...styled.root, ...sx }}>
      {title}
      <YellowRightArrowIcon
        style={{
          marginLeft: "8px",
          transform: downArrow ? "rotate(90deg)" : "",
        }}
      />
    </Box>
  ) : (
    <Link href={href} sx={styled.root}>
      {title}
      <YellowRightArrowIcon
        style={{
          marginLeft: "8px",
          transform: downArrow ? "rotate(90deg)" : "",
        }}
      />
    </Link>
  );
};

export default LinkWithArrow;
